import { ThunkType } from "../../../../core/store/reducers";
import { getDailyTradingReport } from "../api/getDailyTradingReport";
import fileDownload from "js-file-download";
import { setFetchState } from "../dailyTradeDataSlice";

export const downloadOrdersReport = (): ThunkType => async (dispatch, getStore) => {
	const store = getStore();

	if (store.data.auth.current.status !== "successful") {
		return undefined;
	}

	const { filter } = store.ux.reports.dailyTrade;
	const user = store.data.auth.current.user;
	dispatch(setFetchState({ type: "started" }));
	const ordersReport = await dispatch(getDailyTradingReport(user, filter));
	if (ordersReport) {
		fileDownload(new Blob([ordersReport as any], { type: "application/pdf" }), "DailyTrading.pdf");
	}
	dispatch(setFetchState({ type: "not-started" }));
};
